// extracted by mini-css-extract-plugin
export var aboutSection = "index-module--aboutSection--NOcxL";
export var bagelBuzzSection = "index-module--bagelBuzzSection--OWFuB";
export var heroButton = "index-module--heroButton--VXU1h";
export var orderCatering = "index-module--orderCatering--M9MdU";
export var ourLocationsSection = "index-module--ourLocationsSection--IEI6X";
export var whyYoullLoveUs = "index-module--whyYoullLoveUs---IxZd";